import { SyntheticEvent } from 'react'

export const stopBubbling = <Event extends SyntheticEvent>(e?: Event) => {
  if (e && typeof e.stopPropagation === 'function') {
    e.stopPropagation()
  }
}
